// @ts-nocheck
import React, { useEffect, useState, useMemo } from 'react';
import { useAuthAction } from '@ywfe/authmodules';
import { Login } from './auth.login';
import { ResetPassword } from './auth.resetPassword';
import { LoginWxScan } from './auth.loginWxScan';
import { LoginFsScan } from './auth.loginFsScan';
import { YAuthProps } from './auth.interface';
import { YwTab } from '@ywfe/yw-design';
import { FormStyle, LoginLogoStyle, FormBoxStyle, ChangeIconStyle, GlobalStyle, LoginWayStyle } from './styles';
import { delCookie } from '../utils/base';
import { useGetAPI11940 } from '@generated/API11940';

const dataSource = [
  { tab: '飞书', key: '1', },
  { tab: '企业微信', key: '2', },
];
export const YAuth: React.FC<YAuthProps> = (props) => {
  const { actionCodeLogin } = useAuthAction();
  const [showWxLogin, setShowWxLogin] = useState(true);
  const [actionType, setActionType] = useState<string>('login');
  const [pageType, setPageType] = useState<string>('loginByWxScan');
  const { fetchAPI11940Data } = useGetAPI11940();
  const switchType = (key: string) => {
    sessionStorage.setItem('login_type', key);
    setPageType(key);
    setTabKey('1');
    if (key === 'loginByPassword') {
      setActionType('login');
    }
  };

  const changeActionType = (type: string) => {
    setActionType(type);
  };
  const [tabKey, setTabKey] = useState('1');
  const onChange = (tab: string) => {
    setTabKey(tab);
  }

  const init = async () => {
    // iframe打开遥望云，隐藏企业微信登录
    if (typeof window !== 'undefined' && window.self !== window.top) {
      setShowWxLogin(false);
    }
    const condition = (decodeURIComponent(window.location.href)?.includes('=FEISHU&'));
    actionCodeLogin(condition);
  }
  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    init()
  }, []);
  return (
    <FormStyle {...(props.style || {})}>
      <GlobalStyle />
      <FormBoxStyle>
        {actionType === 'login' && (
          <>
            {pageType === 'loginByPassword' && (
              <>
                <div className="title">账号登录</div>
                <span
                  onClick={() => {
                    switchType('loginByWxScan');
                  }}
                >
                  <ChangeIconStyle
                    icon="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/ywwl-website/login/icon_code_normal@2x.png"
                    hoverIcon="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/ywwl-website/login/icon_hover@2x.png"
                  />
                </span>
                <Login onChangeType={() => changeActionType('resetPassword')} />
              </>
            )}
            {pageType === 'loginByWxScan' && (
              <>
                {/* <div className="title">扫码登录</div> */}
                <span
                  onClick={() => {
                    switchType('loginByPassword');
                  }}
                  onMouseEnter={() => { setIsShow(true) }}
                  onMouseLeave={() => { setIsShow(false) }}
                >
                  <ChangeIconStyle
                    icon="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/ywwl-website/login/icon_normal@2x.png"
                    hoverIcon="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/ywwl-website/login/icon_code_hover@2x.png"
                  >
                    {
                      isShow && <span>切换登录</span>
                    }
                  </ChangeIconStyle>
                </span>
                <LoginWayStyle>
                  <YwTab onChange={onChange} dataSource={dataSource} />
                </LoginWayStyle>
                {
                  tabKey === '2' && <LoginWxScan id={props.id} />
                }
                {
                  tabKey === '1' && <LoginFsScan id={props.id} />
                }
              </>
            )}
            {/* <Tabs defaultActiveKey="loginByPassword" onChange={switchType}>
              <TabPane tab="账号密码" key="loginByPassword">
                <ChangeIconStyle
                  icon="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/ywwl-website/login/icon_code_normal@2x.png"
                  hoverIcon="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/ywwl-website/login/icon_hover@2x.png"
                ></ChangeIconStyle>
                <Login onChangeType={() => changeActionType('resetPassword')} />
              </TabPane>
              {showWxLogin && (
                <TabPane tab="企业微信扫码" key="loginByWxScan">
                  <ChangeIconStyle
                    icon="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/ywwl-website/login/icon_normal@2x.png"
                    hoverIcon="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/ywwl-website/login/icon_code_hover@2x.png"
                  >
                    <span>切换登录</span>
                  </ChangeIconStyle>
                  <LoginWxScan />
                </TabPane>
              )}
            </Tabs> */}
          </>
        )}
        {actionType === 'resetPassword' && (
          <ResetPassword
            onChangeType={() => {
              changeActionType('login');
            }}
          />
        )}
      </FormBoxStyle>
    </FormStyle>
  );
};
